export default function TagPill({ label }) {
  return <span className="tag">{label}</span>;
}

